/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PauseTileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {PauseTileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const pauseTile = (request: PauseTileRequest, options?: CashRequestOptions) => post<PauseTileRequest, PauseTileResponse>("/2.0/cash/pause-tile", request, {...options, rejectOnError: true })